function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.908.103a.351.351 0 00-.497 0L8.168 1.346l2.486 2.486 1.243-1.243a.351.351 0 000-.497L9.908.103zM1.346 8.168l2.486 2.486 6.325-6.325-2.486-2.486-6.325 6.325zm7.07-4.585a.351.351 0 010 .497L3.585 8.914a.351.351 0 11-.498-.497L7.92 3.583a.351.351 0 01.497 0zM.944 8.76l-.926 2.777a.352.352 0 00.445.445l2.777-.926L.944 8.76z"
});

function SvgPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "currentColor"
  }, props), _ref);
}

export default SvgPen;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pen.svg
// module id = 1296
// module chunks = 10